import { PropsWithChildren } from 'react';
import { Typography } from '@sanlam-glacier/app-common/components';
import styles from './page-header.module.scss';

export const PageHeader = ({ children }: PropsWithChildren) => {
  return (
    <div className={styles.pageHeader}>
      <Typography variant={Typography.VARIANT.H3} weight={Typography.WEIGHT.MEDIUM}>
        <strong>{children}</strong>
      </Typography>
    </div>
  );
};
